module.exports = {
    reset: {
        en: "Reset",
        fi: "Unohditko salasanasi?"
    },
    emailPlaceholder: {
        en: "Email",
        fi: "Sähköposti"
    },
    submit: {
        en: "Submit",
        fi: "Lähetä"
    }
};